const interactionRequiredListeners = new Set();

export function notifyInteractionRequired(error) {
  interactionRequiredListeners.forEach((listener) => listener(error));
}

export function subscribeToInteractionRequired(listener) {
  interactionRequiredListeners.add(listener);
  return () => interactionRequiredListeners.delete(listener);
}
